{
  "backButton": "Povratak na {prevMenuButton}",
  "moreActions": "Dodatne radnje",
  "unavailable": "Nije dostupno, proširite za detalje"
}
